import { useEffect, useState } from "react";

import PropTypes from "prop-types";

//Material UI Components
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// import FormGroup from "@mui/material/FormGroup";

// import mui icons
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import ConsumerFilterOrder from "utils/ConsumerFilterOrder";
import forwardPng from "../../assets/forward.png";
import GetConsumerFilterOrder, { getMacroCategoryOrder } from "utils/GetConsumerFilterOrder";

//redux
import { useSelector } from "react-redux";

// const customOrder = [...ConsumerFilterOrder.customOrder];

function ActionStandardConsumerFilter({ appliedFilters = {}, handleFilterSubmitData = () => {}, consumerFilter = {}, disableFilter = true, coreData = {} }) {
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const macroOrder = getMacroCategoryOrder(productCategoryData?.label?.toLowerCase());

    const [open, setOpen] = useState(false);
    const [sortedMainFilters, setSortedMainFilters] = useState([]);
    const [sortedSubFilters, setSortedSubFilters] = useState([]);
    const [macroCategories, setMacroCategories] = useState([]);
    const [selectedMacroCategory, setSelectedMacroCategory] = useState("");
    const [visibleMainFilters, setVisibleMainFilters] = useState([]);

    const [selectedFilter, setSelectedFilter] = useState(null);

    const [selectedFiltersData, setSelectedFiltersData] = useState({}); // payload for post/edit and assign same payload data to render in the UI
    const [selectedFiltersLabelData, setSelectedFiltersLabelData] = useState({}); // to show label in ui

    const defaultTitle = coreData?.study_type_method__default_title?.toLowerCase() ?? ""
    const customOrder = GetConsumerFilterOrder(productCategoryData?.label?.toLowerCase(), defaultTitle);
    const customOrderSub = [...ConsumerFilterOrder.customOrderSub];
    const alphabeticOrderFilters = [...ConsumerFilterOrder.alphabeticOrderFilters];

    const getHairCareCustomOrder = (macroCategory) => {
        if (macroCategory === "Consumer Demographics") return ConsumerFilterOrder.ConsumerDemographicsHairCare;
        if (macroCategory === "Study Information") return ConsumerFilterOrder.StudyInformationHairCare;
        if (macroCategory === "Brand recognition") return ConsumerFilterOrder.BrandRecognitionHairCare;
        return [];
    };

    useEffect(() => {
        if (open) {
            setSelectedFiltersData(appliedFilters || {});
        }
    }, [appliedFilters, open]);
    useEffect(() => {
        const datum = { ...selectedFiltersData };
        const labelArray = [];
        const filters = Object.keys(datum) || [];
        if (filters.length !== 0) {
            filters.forEach((bv) => {
                const selectedLabels = datum[bv];
                const displayLabel = consumerFilter["backend_variable_display_label"].filter((ele) => ele.backendVariable === bv)[0]?.displayLabel || "";

                const array = [displayLabel, selectedLabels];
                labelArray.push(array);
            });
        }
        setSelectedFiltersLabelData([...labelArray]);
    }, [selectedFiltersData, consumerFilter]);

    useEffect(() => {
        if (isHairCare) {
            const macroCatMap = consumerFilter["macro_category_display_label_map"] ?? {};
            const macroKeys = Object.keys(macroCatMap);
            if (macroKeys.length > 0) {
                const sortedMacroKeys = macroKeys.slice().sort((a, b) => {
                    const iA = macroOrder.indexOf(a);
                    const iB = macroOrder.indexOf(b);
                    if (iA === -1 && iB === -1) return a.localeCompare(b);
                    if (iA === -1) return 1;
                    if (iB === -1) return -1;
                    return iA - iB;
                });
                setMacroCategories(sortedMacroKeys);
                const firstMacro = sortedMacroKeys[0];
                setSelectedMacroCategory(firstMacro);
                const firstMacroLabels = macroCatMap[firstMacro] || [];
                const allFilters = consumerFilter["backend_variable_display_label"] || [];
                const priorityOrder = getHairCareCustomOrder(firstMacro);
                const visible = allFilters
                    .filter((f) => firstMacroLabels.includes(f.displayLabel))
                    .sort((a, b) => {
                        const iA = priorityOrder.indexOf(a.displayLabel);
                        const iB = priorityOrder.indexOf(b.displayLabel);
                        if (iA === -1 && iB === -1) return a.displayLabel.localeCompare(b.displayLabel);
                        if (iA === -1) return 1;
                        if (iB === -1) return -1;
                        return iA - iB;
                    });
                setVisibleMainFilters(visible);
                setSelectedFilter(visible?.[0] ?? null);
            } else {
                const allFilters = consumerFilter["backend_variable_display_label"] || [];
                setVisibleMainFilters(allFilters);
                setSelectedFilter(allFilters[0] ?? null);
            }
        } else {
            const array = sortMainFilters(consumerFilter["backend_variable_display_label"]) || [];
            setSortedMainFilters([...array]);
            setSelectedFilter(array?.[0] || null);
        }
    }, [consumerFilter]);

    useEffect(() => {
        if (selectedFilter?.backendVariable) {
            const array = sortSubFilters(selectedFilter.backendVariable, selectedFilter.displayLabel) || [];
            setSortedSubFilters([...array]);
        }
    }, [selectedFilter]);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };

    const handleClickAway = () => {
        // setOpen(false);
    };
    const handleMacroCategoryClick = (macroCategory) => {
        const macroCatMap = consumerFilter["macro_category_display_label_map"] ?? {};
        const labelsInMacro = macroCatMap[macroCategory] || [];
        const allFilters = consumerFilter["backend_variable_display_label"] || [];
        const priorityOrder = getHairCareCustomOrder(macroCategory);
        const visible = allFilters
            .filter((f) => labelsInMacro.includes(f.displayLabel))
            .sort((a, b) => {
                const iA = priorityOrder.indexOf(a.displayLabel);
                const iB = priorityOrder.indexOf(b.displayLabel);
                if (iA === -1 && iB === -1) return a.displayLabel.localeCompare(b.displayLabel);
                if (iA === -1) return 1;
                if (iB === -1) return -1;
                return iA - iB;
            });
        setSelectedMacroCategory(macroCategory);
        setVisibleMainFilters(visible);
        setSelectedFilter(visible?.[0] ?? null);
    };

    const openButtons = () => {
        return (
            <div
                style={{
                    fontSize: "0.75rem",
                    color: "#4d4d4d",
                    width: "100%",
                }}
            >
                <button
                    onClick={handleClick}
                    style={{
                        // cursor: "pointer",
                        outline: "none",
                        border: "none",
                        borderRadius: "5px",
                        padding: "1px 20px",
                    }}
                    type="button"
                    disabled={disableFilter}
                >
                    {
                        <ManageAccountsIcon
                            fontSize="small"
                            className={disableFilter ? "" : "color-blue"}
                            sx={{
                                margin: "0px 5px 0px 0px",
                            }}
                        />
                    }
                    <span
                        style={{
                            fontWeight: 600,
                        }}
                    >
                        Filters
                    </span>
                    {
                        <ArrowDropDownIcon
                            className={disableFilter ? "" : "color-blue"}
                            sx={{
                                margin: "0px 0px 0px 5px",
                            }}
                        />
                    }
                </button>
            </div>
        );
    };

    const handleFilterLabelClick = (filter) => {
        setSelectedFilter(filter);
    };

    const handleOnChange = (event, selectedFilter, label, type = "individualCheck") => {
        const backendVariable = selectedFilter?.backendVariable || null;
        const datum = { ...selectedFiltersData };

        if (type === "individualCheck") {
            if (backendVariable && label) {
                const selectedFilterForBackendVariable = datum?.[backendVariable] || [];
                if (event.target.checked) {
                    datum[backendVariable] = [...selectedFilterForBackendVariable, label];
                } else {
                    const index = selectedFilterForBackendVariable.indexOf(label);
                    if (index !== -1) {
                        selectedFilterForBackendVariable.splice(index, 1);
                    }
                    datum[backendVariable] = [...selectedFilterForBackendVariable];
                }
                if (datum[backendVariable].length === 0) {
                    delete datum[backendVariable];
                }
            }
        } else if (type === "allCheck") {
            if (backendVariable) {
                if (event.target.checked) {
                    datum[backendVariable] = [...consumerFilter["backend_variable_mapping"][selectedFilter?.backendVariable]];
                } else {
                    datum[backendVariable] = [];
                }
                if (datum[backendVariable].length === 0) {
                    delete datum[backendVariable];
                }
            }
        }

        setSelectedFiltersData({ ...datum });
    };

    const sortMainFilters = (arr) => {
        const array =
            arr?.sort((a, b) => {
                const indexA = customOrder.indexOf(a.displayLabel);
                const indexB = customOrder.indexOf(b.displayLabel);
                if (indexA === -1 && indexB === -1) {
                    return a.displayLabel.localeCompare(b.displayLabel);
                }
                if (indexA === -1) {
                    return 1;
                }
                if (indexB === -1) {
                    return -1;
                }
                return indexA - indexB;
            }) || arr;

        return array;
    };

    const sortSubFilters = (backendVariable, displayLabel) => {
        const array = JSON.parse(JSON.stringify(consumerFilter?.["backend_variable_mapping"]?.[backendVariable]) || []);
        if (!alphabeticOrderFilters.includes(displayLabel)) {
            array.sort((a, b) => {
                const indexA = customOrderSub.indexOf(a);
                const indexB = customOrderSub.indexOf(b);

                // If an element is not found in customOrderSub, move it to the start (by returning -1)
                if (indexA === -1 && indexB === -1) return 0; // both are extra, maintain their order
                if (indexA === -1) return -1; // a is extra, move it to the start
                if (indexB === -1) return 1; // b is extra, move it to the start

                // Otherwise, sort based on the order in array1
                return indexA - indexB;
            });
        }
        return array;
    };

    return (
        <ClickAwayListener
            mouseEvent="onMouseDown"
            touchEvent="onTouchStart"
            onClickAway={handleClickAway}
        >
            <Box sx={{ position: "relative" }}>
                {openButtons()}
                {open && (
                    <Box
                        role="presentation"
                        sx={{
                            position: "absolute",
                            top: 28,
                            // right: 0,
                            left: 10,
                            border: "1px solid #dee2e6",
                            bgcolor: "background.paper",
                            width: isHairCare ? 650 : 500,
                            zIndex: 1,
                            maxHeight: 400,
                            minHeight: 400,
                            borderRadius: 5,
                            overflow: "hidden",
                        }}
                        className="box-shadow--2"
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                maxHeight: 400,
                                minHeight: 400,
                            }}
                        >
                            {/* Panel 1 — Macro Categories (Hair Care only) */}
                            {isHairCare && macroCategories.length > 0 && (
                                <div
                                    style={{
                                        width: "33%",
                                        fontSize: "12px",
                                        background: "#9c27b0",
                                        overflowY: "scroll",
                                    }}
                                >
                                    {macroCategories.map((macro, i) => (
                                        <div
                                            key={i}
                                            style={{
                                                margin: "2px 0",
                                                cursor: "pointer",
                                                padding: "10px 20px",
                                                width: "100%",
                                            }}
                                            className={selectedMacroCategory === macro ? "remove-opacity" : "enable-filter"}
                                            onClick={() => handleMacroCategoryClick(macro)}
                                        >
                                            <span style={{ fontSize: "0.75rem", color: "#fff", fontWeight: 600 }}>{macro}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {/* Panel 2 — Filter Labels */}
                            <div
                                style={{
                                    width: isHairCare ? "33%" : "50%",
                                    fontSize: "12px",
                                    background: isHairCare ? "linear-gradient(0deg, rgba(126,168,233,1) 0%, rgba(255,255,255,1) 100%)" : "#005eefa8",
                                    overflowY: "scroll",
                                }}
                            >
                                {(isHairCare ? visibleMainFilters : sortedMainFilters).map((ele, i) => (
                                    <div
                                        key={i}
                                        style={{
                                            padding: "5px 10px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            borderBottom: "0.5px solid #bbb",
                                            fontWeight: selectedFilter?.backendVariable === ele?.backendVariable ? 600 : 500,
                                            color: isHairCare ? selectedFilter?.backendVariable === ele?.backendVariable ? "#4d4d4d" : Object.keys(selectedFiltersData).indexOf(ele?.backendVariable) !== -1 ? "#1565c0": "#4d4d4d"
                                                              : selectedFilter?.backendVariable === ele?.backendVariable ? "#fff" : Object.keys(selectedFiltersData).indexOf(ele?.backendVariable) !== -1 ? "#98FF98" : "#eee",

                                        }}
                                        onClick={() => handleFilterLabelClick(ele)}
                                    >
                                        <span
                                            style={{
                                                fontSize: "0.75rem",
                                            }}
                                        >
                                            {ele.displayLabel}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            {/* Panel 3 — Checkboxes */}
                            <div
                                style={{
                                    width: isHairCare ? "34%" : "50%",
                                    padding: "10px 0px 0px 10px",
                                    fontSize: "12px",
                                }}
                            >
                                <div
                                    style={{
                                        maxHeight: 350,
                                        minHeight: 350,
                                        overflowY: "scroll",
                                        padding: "5px",
                                    }}
                                >
                                    {selectedFilter && (
                                        <FormControlLabel
                                            key={selectedFilter?.backendVariable}
                                            label="Select All"
                                            sx={{
                                                "& .MuiTypography-root": {
                                                    fontSize: 12,
                                                    margin: "5px 0px",
                                                    padding: 0,
                                                    display: "block",
                                                    paddingLeft: 1,
                                                },
                                            }}
                                            control={
                                                <Checkbox
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            fontSize: 18,
                                                            padding: 0,
                                                        },
                                                    }}
                                                    style={{
                                                        padding: 5,
                                                    }}
                                                    color="secondary"
                                                    checked={
                                                        consumerFilter["backend_variable_mapping"]?.[selectedFilter?.backendVariable]?.length &&
                                                        selectedFiltersData?.[selectedFilter?.backendVariable]?.length &&
                                                        consumerFilter["backend_variable_mapping"]?.[selectedFilter?.backendVariable]?.length === selectedFiltersData?.[selectedFilter?.backendVariable]?.length
                                                            ? true
                                                            : false
                                                    }
                                                    onChange={(event) => handleOnChange(event, selectedFilter, null, "allCheck")}
                                                />
                                            }
                                        />
                                    )}
                                    {sortedSubFilters?.map((label) => {
                                        return (
                                            <div key={label}>
                                                <FormControlLabel
                                                    key={label}
                                                    sx={{
                                                        "& .MuiTypography-root": {
                                                            fontSize: 12,
                                                            margin: "5px 0px",
                                                            padding: 0,
                                                            display: "block",
                                                            paddingLeft: 1,
                                                        },
                                                    }}
                                                    style={{
                                                        margin: "0px 0px 0px 0px",
                                                        textAlign: "left",
                                                    }}
                                                    control={
                                                        <Checkbox
                                                            sx={{
                                                                "& .MuiSvgIcon-root": {
                                                                    fontSize: 18,
                                                                    padding: 0,
                                                                },
                                                            }}
                                                            style={{
                                                                padding: 5,
                                                            }}
                                                            color="secondary"
                                                            checked={selectedFiltersData && selectedFiltersData?.[selectedFilter?.backendVariable] ? selectedFiltersData?.[selectedFilter?.backendVariable].indexOf(label) !== -1 : false}
                                                            onChange={(event) => handleOnChange(event, selectedFilter, label, "individualCheck")}
                                                            value={label}
                                                        />
                                                    }
                                                    label={label.replace(/ \|/g, ",").trim()}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                                <div>
                                    <svg
                                        style={{
                                            position: "absolute",
                                            bottom: -10,
                                        }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 1440 320"
                                    >
                                        <path
                                            fill="#9c27b0"
                                            fillOpacity="1"
                                            d="M0,288L60,288C120,288,240,288,360,250.7C480,213,600,139,720,101.3C840,64,960,64,1080,106.7C1200,149,1320,235,1380,277.3L1440,320L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
                                        ></path>
                                    </svg>
                                    <div
                                        className="px-2 py-1"
                                        style={{
                                            position: "absolute",
                                            right: 80,
                                            bottom: 5,
                                            cursor: "pointer",
                                            width: 35,
                                            height: 25,
                                            overflow: "hidden",
                                        }}
                                        onClick={() => {
                                            handleFilterSubmitData(selectedFiltersData, selectedFiltersLabelData);
                                            setOpen(false);
                                        }}
                                    >
                                        <img
                                            style={{
                                                width: 25,
                                                height: 20,
                                                color: "white",

                                                filter: "brightness(0) invert(1)",
                                            }}
                                            src={forwardPng}
                                            alt={"forward"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>
                )}
            </Box>
        </ClickAwayListener>
    );
}

ActionStandardConsumerFilter.propTypes = {
    appliedFilters: PropTypes.object,
    filterData: PropTypes.object,
    handleFilterSubmitData: PropTypes.func,
    handleFilterLabelData: PropTypes.func,
    disableFilter: PropTypes.bool,
    consumerFilter: PropTypes.object,
    coreData: PropTypes.object,
};

export default ActionStandardConsumerFilter;
